import {Component, Input, OnInit} from '@angular/core';
import {FintechService} from "../../../../services/fintech.service";
import {
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCcVisa
} from "@fortawesome/free-brands-svg-icons";

@Component({
  selector: 'app-fintech-pay-method-info',
  templateUrl: './fintech-pay-method-info.component.html',
  styleUrl: './fintech-pay-method-info.component.scss'
})
export class FintechPayMethodInfoComponent implements OnInit {

    private _payMethodInfo: any;


    @Input()
    set payMethodInfo(value: any) {
        this._payMethodInfo = value;
        this.cardIcon = (this.payMethodInfo != null) ? this.iconMap[this.payMethodInfo.cardBrand] : null;
    }
    get payMethodInfo(): any {
        return this._payMethodInfo;
    }


    iconMap = { visa : faCcVisa, mastercard: faCcMastercard, amex: faCcAmex, diners: faCcDinersClub, discover: faCcDiscover, jcb: faCcJcb  };

    cardIcon;
    cardOpacity = 1;
    fintechIcon;

    constructor(public fintechService: FintechService) {
    }


    ngOnInit(): void {

    }

    getStatusColor() {

    }

    getStatus() {

    }
}
